import { useState } from 'react'

import { ReportReasonModal, ReportSubmitModal, ReportSuccessModal } from './steps'

export const ReportEventModal = ({ event, onClose, onCancel }) => {
  const [step, setStep] = useState('reason')
  const [reason, setReason] = useState('')
  const [reasonType, setReasonType] = useState('')

  const onChooseReason = (value, key) => {
    setReason(value)
    setReasonType(key)
    setStep('submit')
  }

  const handleCancel = onCancel || onClose

  if (step === 'reason') {
    return <ReportReasonModal onClose={handleCancel} onChooseReason={onChooseReason} />
  }

  if (step === 'submit') {
    return (
      <ReportSubmitModal
        event={event}
        reason={reason}
        reasonType={reasonType}
        onClose={handleCancel}
        onSuccess={() => setStep('success')}
        onBack={() => setStep('reason')}
      />
    )
  }

  if (step === 'success') {
    return <ReportSuccessModal onClose={onClose} />
  }

  return null
}
